module.exports = __webpack_public_path__ + "va.svg?e486a73486de2ab83e854608429809d2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/va.svg
// module id = 1218
// module chunks = 27